<script setup lang="ts">
import type { BaseColumnData } from '@/utils/tables/column-data';
import SimpleTable from '../tables/SimpleTable.vue';

interface AtaChangelogData {
  id: string;
  user: string;
  change: string;
  timestamp: string;
}

const props = defineProps<{ changes: AtaChangelogData[] }>();

const columns: BaseColumnData[] = [
  {
    key: 'user',
    label: 'Användare',
    columnWidth: '20%',
  },
  {
    key: 'change',
    label: 'Förändring',
    columnWidth: '55%',
  },
  {
    key: 'timestamp',
    label: 'Tidpunkt',
    sortable: true,
    columnWidth: '25%',
  },
];
</script>
<template>
  <SimpleTable :columns="columns" :data="props.changes" class="changelog-table">
    <template #tbody="{ data }">
      <tr v-for="row in data" :key="row.id">
        <td
          v-for="(column, index) in columns"
          :key="index"
          :class="[
            column.align || '',
            column.class ? column.class(row[column.key]) : '',
          ]"
        >
          <span>{{ row[column.key] }}</span>
        </td>
      </tr></template
    >
  </SimpleTable>
</template>

<style scoped lang="scss">
.changelog-table {
  overflow: hidden;
  width: 100%;
  min-width: 0;

  :deep(table) {
    table-layout: fixed;
    width: 100%;
  }

  :deep(td),
  :deep(th) {
    word-wrap: break-word;
    overflow-wrap: anywhere;
    word-break: break-word;
    white-space: normal;
    max-width: 0;
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  :deep(td span),
  :deep(th span) {
    display: block;
    overflow: hidden;
    word-wrap: break-word;
    overflow-wrap: anywhere;
  }

  :deep(th) {
    font-weight: 600;
  }
}
</style>
